import React from 'react';
// Components
import SetupStream from 'components/common/SetupStream/SetupStream';

const SetupContentCreatorStream = (): JSX.Element => {
  return <SetupStream />;
};

export default SetupContentCreatorStream;
